import aggregateModels from './aggregate-models'
import calculator from './calculator'
import elections from './elections'
import electionModels from './election-models'
import geojson from './geojson'
import landingModels from './landing-models'
import pages from './pages'
import ux from './ux'

export default {
  aggregateModels,
  calculator,
  elections,
  electionModels,
  geojson,
  landingModels,
  pages,
  ux
}



// WEBPACK FOOTER //
// ./src/modules/index.js